export default {"src":"/_next/static/media/big-point.3263ac5f.svg","height":32,"width":32};